import React, { useCallback, memo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

function HeaderItem({ column, active, onSort, isSorted }) {
  const { mainTheme } = useSelector((state) => state.Layout);
  const { t } = useTranslation();

  const renderSortIcon = useCallback(() => {
    if (!isSorted) return null;
    if (!active) return <i className="bx bx-sort font-size-14" />;
    if (active === "asc") return <i className="bx bx-sort-up font-size-16" />;
    return <i className="bx bx-sort-down font-size-16" />;
  }, [active, isSorted]);

  const handleSort = useCallback(() => {
    if (isSorted) onSort?.(column.path);
  }, [column, isSorted, onSort]);

  return (
    <div
      className={`header-item ${column.path} ${isSorted ? "sorted" : ""}
        ${column.fixed ? "fixed" : ""}
       ${mainTheme}`}
      key={column.path || column.key}
      onClick={handleSort}
    >
      {t(column.label)} {renderSortIcon(column)}
    </div>
  );
}

export default memo(HeaderItem);
